import { z } from 'zod';
import type { FilterValue } from './params';

/** Допустимые размеры страницы реестров админки (ТЗ API-07). */
export const PAGE_SIZES = [25, 50, 100] as const;
export type PageSize = (typeof PAGE_SIZES)[number];
export const DEFAULT_PAGE_SIZE: PageSize = 25;

export function isPageSize(value: number): value is PageSize {
  return PAGE_SIZES.some((size) => size === value);
}

/** Параметры списка админки: page/page_size/sort/q/filter[…] (ТЗ API-07). */
export interface ListQuery {
  page: number;
  page_size: PageSize;
  sort?: string;
  q?: string;
  filter?: Readonly<Record<string, FilterValue>>;
}

/** Флаги прав уровня реестра (docs/backend/conventions.md §4.5): `{create, export}`. */
export const listAbilitiesSchema = z.object({
  create: z.boolean().optional(),
  export: z.boolean().optional(),
});

/** Ответ списка админки: `{items, total, can}`; `last_page` считается на клиенте. */
export function listResponseSchema<TItem extends z.ZodType>(item: TItem) {
  return z.object({
    items: z.array(item),
    total: z.number().int().nonnegative(),
    can: listAbilitiesSchema.optional(),
  });
}

export interface ListResponse<TItem> {
  items: TItem[];
  total: number;
  can?: { create?: boolean; export?: boolean };
  /** Плашка области видимости от сервера (`WineryPageOut.notice`: «Показаны только …»). */
  notice?: string | null;
}

export function lastPage(total: number, pageSize: number): number {
  return Math.max(1, Math.ceil(total / pageSize));
}
